<template>
  <div
    class="article-wrapper"
    @mouseenter="mouseHover = true"
    @mouseleave="mouseHover = false"
  >
    <div
      id="article-buttons"
      v-if="(mouseHover && !showSnippet) || toggleFavorites || isPinned"
    >
      <button
        id="create-button"
        class="btn-flat"
        v-if="isAdmin && mouseHover"
        @click="handleClick(true)"
      >
        <i class="material-icons">create</i>
      </button>
      <button
        id="checkbox-or-bookmark-button"
        class="btn-flat transparent"
        v-if="isAdmin"
        @click="clickOnPin"
      >
        <i class="material-icons flagg" v-if="isPinned">bookmark</i>
        <i class="material-icons" v-if="!isPinned && mouseHover"
          >bookmark_border</i
        >
      </button>
      <button
        id="bookmark-button"
        class="btn-flat transparent"
        v-if="!isAdmin && isPinned"
      >
        <i class="material-icons flagg student-view" v-if="isPinned">flagg</i>
      </button>
      <!-- <div v-if="isAdmin && !mouseHover" id="fake-icon"></div>
        <button v-if="showStar && mouseHover" id="star-button">
          <i>star</i>
        </button> -->
    </div>
    <div id="article-item" :class="{ 'not-creating-article': !showSnippet }">
      <div id="article-link" @click.stop.prevent="handleClick">
        <a :href="'/article/' + article.slug">
          <p class="article-title black-text" :class="{ draft: !isPublished }">
            {{ article.title }}
          </p>
        </a>
      </div>
      <div id="time">
        <p class="grey-text">{{ timePosted }}</p>
      </div>
      <div id="categories">
        <span v-if="showKlasses" class="klasses">
          <span
            v-for="(klass, i) in article.klasses"
            :key="klass + i"
            class="klass grey-text text-darken-1"
            ><span class="klass-name" @click="filterKlass(klass)">{{
              klass
            }}</span>
            <span class="category-divider grey-text text-lighten-1">
              |
            </span>
          </span>
        </span>
        <!-- <span v-if="showKlasses">|</span> -->
        <span
          v-for="(category, i) in article.categories"
          :key="category + i"
          @click="filterCategory(category)"
          ><span class="category-name grey-text text-darken-1">{{
            category
          }}</span>
          <span
            class="category-divider grey-text text-lighten-1"
            v-if="!(i === article.categories.length - 1)"
          >
            |
          </span>
        </span>
      </div>
      <p v-if="showSnippet" id="snippet" @click.stop.prevent="handleClick">
        {{ article.snippet }}
      </p>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from "vue-property-decorator";
import { Api } from "@/utils";

@Component
export default class ArticleItem extends Vue {
  @Prop() article;
  @Prop() showSnippet;
  @Prop() showKlasses;
  @Prop() toggleFavorites;
  mouseHover = false;

  addFavorite() {
    if (this.isFavorite) {
      this.$store.commit("removeFavorite", this.article);
    } else {
      this.$store.commit("addFavorite", this.article);
    }
  }

  async handleClick(ignorePath) {
    if (ignorePath === true || /\/create-article.*/.test(this.$route.path)) {
      this.$store.commit("setCreateArticleSlugToLoad", {
        slug: this.article.slug,
        title: this.article.title,
      });
      this.$store.commit("toggleCreateArticleList", false);
      this.$router.push({
        name: "createArticle",
        params: {
          slug: this.article.slug,
        },
      });
    } else
      this.$router.push({
        name: "article",
        params: {
          slug: this.article.slug,
        },
      });
  }

  get isFavorite() {
    return !!this.$store.state.user.favorites.filter(
      (a) => a.id === this.article.id
    )[0];
  }

  get isPinned() {
    return this.article.pinned;
  }

  get isMobile() {
    return this.$store.state.isMobile;
  }

  set isPinned(val) {
    this.article.pinned = val;
  }

  async clickOnPin() {
    this.isPinned = !this.isPinned;
    const props = {
      articleId: this.article.id,
      klassSlug: this.$store.state.currentKlass,
      pinned: this.isPinned,
    };
    await Api.put("pin-article", props);
  }

  get showStar() {
    // return $route.name == 'home'
    return false;
  }

  get user() {
    return this.$store.state.user.loggedInUser;
  }

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }

  filterCategory(category) {
    this.$store.commit("addCategory", category);
  }

  filterKlass(klass) {
    this.$store.commit("setCurrentKlass", klass);
  }

  get isPublished() {
    const hasMyKlass = this.article.klasses.find(
      (k) => k.slug == this.$store.getters.classNameInUrl
    );

    if (hasMyKlass) {
      return (
        typeof hasMyKlass.publishedAt == "number" && hasMyKlass.publishedAt != 0
      );
    } else {
      return this.article.publishedAt != 0;
    }
  }

  get timePosted() {
    return new Date(
      this.isPublished ? this.article.publishedAt : this.article.createdAt
    )
      .toLocaleString("sv-SE")
      .substr(0, 10);
  }

  klassColor(i) {
    if (this.$store.state.klasses.hasOwnProperty(this.article.klasses[i]))
      return this.$store.state.klasses[this.article.klasses[i]].color;
    else return "black";
  }

  categoryColor(i) {
    let a = this.$store.state.article.categories[i];
    if (this.$store.state.article.categoryColors.has(a))
      return this.$store.state.article.categoryColors.get(a).color;
    else return "black";
  }
}
</script>

<style scoped lang="scss">
.article-wrapper {
  animation-duration: 150ms;
  display: grid;
  border-radius: 5px;
  grid-template-columns: 3% 97%;
  margin: 0.5em 1em;
  #article-buttons {
    align-items: center;
    display: grid;
    grid-template-rows: repeat(2, 1fr);
    grid-column: 1/2;
    grid-row: 1/3;
    .btn-flat {
      height: 2em; 
      line-height: 2.5em;
    }
    #create-button {
      align-self: start;
      grid-row: 2/3;
    }
    #checkbox-or-bookmark-button {
      align-self: end;
      grid-row: 1/2;
    }
    #bookmark-button {
      align-self: end;
      grid-row: 1/2;
    }
    .btn-flat {
      padding: 0;
      i:hover {
        color: grey !important;
      }
    }
  }
  #article-item {
    border-radius: 5px;
    display: grid;
    grid-template-columns: 85% 15%;
    padding: 0.2em 0 0.2em 0.3em;
    grid-column: 2/3;
    #article-link {
      align-self: end;
      grid-column: 1/2;
      grid-row: 1/2;
      .article-title {
        font-family: "Libre Franklin";
        font-size: 1.4em;
        font-weight: 700;
        color: rgb(51, 51, 51) !important;
        line-height: 1.3em;
        margin: 0;
      }
    }
    #time {
      align-self: center;
      justify-self: center;
      grid-column: 2/3;
      p {
        margin: 0;
      }
    }
    #categories {
      font-size: 0.9em;
      margin-left: 1px;
      cursor: pointer;
      grid-column: 1/2;
      grid-row: 2/3;
      .klass-name {
        font-weight: bold;
      }
      .category-name {
        background-color: var(--main-background-color);
      }

      .category-name:hover,
      .klass-name:hover {
        text-decoration: underline;
      }
    }
      @media screen and (max-width: 600px) {
      #categories {
        font-size: 0.8em;
      }
      #time {
        font-size: 0.8em;
      }
    }
  }
}

.article-wrapper:hover {
  background: #eaeaea !important;
  .category-name {
    background-color:#eaeaea !important;
  }
}

#create-article-textarea {
  .article-wrapper {
    grid-template-columns: 1fr;
    padding-left: 0.5em;
    #article-buttons {
      display: none;
    }
    #article-item {
      grid-gap: 0;
      row-gap: 5px;
      grid-template-columns: 8fr 2fr;
      grid-auto-rows: minmax(10px, auto);
      padding: 0;
      #article-link {
        grid-column: 1;
        padding: 0;
      }
      #categories {
        grid-column: 1;
      }
      #snippet {
        cursor: pointer;
        grid-column: 1;
        margin: 0;
      }
    }
  }
}

@media (max-width: 992px) {
  #article-wrapper {
    grid-template-columns: 100% !important;
    padding: 0.5em 0 0.5em 1.2em !important;
  }
}

@media (max-width: 600px) {
  #article-item {
    grid-template-columns: 100% !important;
    #time {
      grid-column: 1/2 !important;
      grid-row: 2/3 !important;
      justify-self: end !important;
    }
  }
}

a {
  text-decoration: none;
  color: rgb(32, 32, 32);
  h2 {
    font-weight: 700;
    &:hover {
      text-decoration: underline;
    }
  }
  .draft {
    opacity: 0.5;
  }
}

.mobile {
  .article-wrapper {
    margin: 0.5em 0;
    padding-right: 15px;
  }
  #article-item {
    padding-left: 0.7em;
  }
}
</style>
